import React from "react";
import {ACCEPTED_FILE_TYPES} from "../constants";
import {FileInput, ChooseButton} from "../atoms";
import {selectFiles} from "../lib/fileHandlers";

function FilesControls({files, status, setFiles, setStatus, setIsLoadingStarted, getNextSerial}) {
    return (
        <>
            <label htmlFor="upload-data">
                <FileInput
                    files={files}
                    selectFiles={(e) => selectFiles(e, files, setFiles, setStatus, setIsLoadingStarted, getNextSerial)}
                    ACCEPTED_FILE_TYPES={ACCEPTED_FILE_TYPES}
                />
                <ChooseButton status={status} />
            </label>
        </>
    );
}

export default FilesControls;
